import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getUserOrders } from "../apiCalls/order";
import moment from "moment";
import OrderConfirmImg from "../assets/images/order-confirmed.png";
import noOrder from "../assets/images/empty/cart.gif";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const Success = () => {
  const location = useLocation();
  const orderData = location.state;

  return (
    <>
      <Breadcrumb
        activeName={"Order Successfull"}
        middleName={"My Account"}
        middleUrl={"/my-account"}
      />
      {orderData ? (
        <section className="success">
          <div className="container">
            <div className="confirmation-area">
              <div className="confirmation-img">
                <img
                  src={OrderConfirmImg}
                  height="400"
                  width="400"
                  className="img-fluid"
                  alt="Order Confirmed"
                />
              </div>

              <h1 className="confirmation-heading text-center">
                Order Confirmed
              </h1>
              <p className="sub-heading text-center">
                Thankyou for placing an order with us. <br />
              </p>
              <div className="confirm-btn  text-center">
                <Link to="/my-orders" className="btn">
                  Check your Order
                </Link>
              </div>

              <ul className="order-details">
                <li>
                  <p className="success-title">Order Date :</p>
                  <p className="text">
                    {" "}
                    {moment(orderData?.createdAt).format("LL")} at{" "}
                    {moment(orderData?.createdAt).format("LT")}
                  </p>
                </li>
                <li>
                  <p className="success-title">Order ID :</p>
                  <p className="text">
                    {orderData._id} <span>({orderData.orderId})</span>
                  </p>
                </li>
                <li>
                  <p className="success-title">Transaction ID :</p>
                  <p className="text">62945c3173e8c6fec25e2e57</p>
                </li>

                <li>
                  <p className="success-title">Order Status :</p>
                  <p className="text order-status">{orderData.status}</p>
                </li>
                <li>
                  <p className="success-title">
                    Pay Amount :
                    <p className="payment-method">
                      Payment Method: ({orderData.paymentMethod})
                    </p>
                  </p>
                  <p className="text">
                    <small>₹</small>
                    {orderData.payAmount}.00
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
      ) : (
        <section className="success">
        <div className="container">
          <div className="confirmation-area">
            <div className="confirmation-img">
              <img
                src={noOrder}
                height="400"
                width="400"
                className="img-fluid"
                alt="Order Confirmed"
              />
            </div>

            <h1 className="confirmation-heading text-center">
              No Order Found
            </h1>
            <p className="sub-heading text-center">
              Please make one and give us a chance to deliver you something amazing. <br />
            </p>
            <div className="confirm-btn  text-center">
              <Link to="/products" className="btn">
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </section>
      )}
    </>
  );
};

export default Success;
